module.exports = __webpack_public_path__ + "mn.b2185c1f.svg";